export const ButtonOptionsFormFieldOptionProp = Object.freeze({
    Key: 'key',
    Value: 'value',
    Text: 'text',
    Position: 'position',
    SelectedColor: 'selectedColor',
    NotSelectedColor: 'notSelectedColor',
    OnClickEvent: 'onClickEvent',
    Popup: 'popup',
    DisableWhenClicked: 'disableWhenClicked',
});
